
import React, { useState } from "react"
import { pki } from "node-forge"
import classNames from "classnames"

const GeneratePrivateKey = ({onKeyCreated}) => {
  const [inProgress, setInProgress] = useState(false)
  const [keyLength, setKeyLength] = useState(2048)
  const [password, setPassword] = useState("")
  const [repeat, setRepeat] = useState("")
  const [hasKey, setHasKey] = useState(false)

  if (!onKeyCreated) {
    // Default callback
    onKeyCreated = (key, pem) => console.log(pem)
  }

  const generateKey = () => {
    if (password && password != repeat) {
      // Return early if password don't match
      return
    }
    setInProgress(true)
    pki.rsa.generateKeyPair(keyLength, (error, keys) => {
      // Keys ready callback
      setInProgress(false)
      if (error) {
        console.log(error)
        return
      }
      let pem;
      if (password) {
        pem = pki.encryptRsaPrivateKey(keys.privateKey, password)
      } else {
        pem = pki.privateKeyToPem(keys.privateKey)
      }

      setPassword("")
      setRepeat("")
      onKeyCreated(keys, pem)
      setHasKey(true)
    })
  }

  return (<>
    <form onSubmit={(e) => e.preventDefault()}>
      <div className="form-group">
        <label htmlFor="key-length">Key length</label>
        <select className="custom-select" id="key-length" value={keyLength}
                onChange={e => setKeyLength(parseInt(e.target.value))}>
          <option>1024</option>
          <option>2048</option>
          <option>4096</option>
        </select>
      </div>
      <div className="form-group">
        <label htmlFor="password">Password <small className="text-muted">(optional, to encrypt key)</small></label>
        <input className="form-control" id="password" type="password"
                value={password}
                onChange={e => setPassword(e.target.value)} />
      </div>

      <div className="form-group">
        <label htmlFor="password">Repeat password</label>
        <input className={classNames("form-control",
                                     {"is-invalid": password != repeat })}
               id="password" type="password"
               value={repeat}
               onChange={e => setRepeat(e.target.value)} />

        <div className="invalid-feedback">Password don't match</div>
      </div>

      <button type="button"
              className={classNames("btn",
                                    {"btn-primary": !hasKey},
                                    {"btn-outline-primary": hasKey})}
              disabled={inProgress || (password != repeat)}
              onClick={() => generateKey()}>
        { inProgress && <>
            <span className="spinner-border spinner-border-sm"
                  role="status" aria-hidden="true"></span> {' '}
          </>
        }
        Generate {hasKey && "new" } private key
      </button>
    </form>
  </>)
}

export default GeneratePrivateKey
